var App = App || {};

App.BlogTestimonials = (function ($) {
    "use strict";

    function init() {
        $(window).on('load resize', function () {
            $('.blog-testimonial').each(function () {
                if ($(window).width() > 768) {
                    if ($(this).find('.blog-testimonial__image-container').height() > $(this).height() + 40) {
                        $(this).height($(this).find('.blog-testimonial__image-container').height());
                    }
                    else {
                        $(this).height('auto');
                    }
                }
                else {
                    $(this).height('auto');
                }
            })
        });
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.BlogTestimonials.init();
});